import { API_URL } from "../Constant";

const ApiKey = {
  api:API_URL,
};


export default ApiKey;
